import React, { useState } from 'react';

const ModalCrearHorario = ({
  show,
  onClose,
  onSubmit,
  sucursales,
  horarios,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    sucursal_id: null,
    copiar_de: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre.trim()) {
      alert('El nombre es obligatorio');
      return;
    }
    if (!formData.sucursal_id) {
      alert('Selecciona una sucursal');
      return;
    }
    await onSubmit(formData);
    setFormData({ nombre: '', descripcion: '', sucursal_id: null, copiar_de: null });
  };

  const handleClose = () => {
    setFormData({ nombre: '', descripcion: '', sucursal_id: null, copiar_de: null });
    onClose();
  };

  if (!show) return null;

  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    width: '100%',
    marginTop: '0.5rem',
    transition: 'all 0.2s'
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '500px',
          borderRadius: '16px',
          overflow: 'hidden'
        }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>📅</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              Nuevo Horario
            </h3>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Nombre *
            </label>
            <input
              type="text"
              value={formData.nombre}
              onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
              placeholder="Ej: Horario Normal"
              style={inputStyle}
              disabled={loading}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Descripción
            </label>
            <textarea
              value={formData.descripcion}
              onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
              placeholder="Descripción opcional"
              style={{ ...inputStyle, minHeight: '80px', fontFamily: 'inherit' }}
              disabled={loading}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Sucursal *
            </label>
            <select
              value={formData.sucursal_id || ''}
              onChange={(e) => setFormData({ ...formData, sucursal_id: Number(e.target.value) })}
              style={inputStyle}
              disabled={loading}
            >
              <option value="">-- Selecciona una sucursal --</option>
              {sucursales.map(s => (
                <option key={s.id} value={s.id}>
                  {s.nombre}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Copiar de (opcional)
            </label>
            <select
              value={formData.copiar_de || ''}
              onChange={(e) => setFormData({ ...formData, copiar_de: e.target.value ? Number(e.target.value) : null })}
              style={inputStyle}
              disabled={loading}
            >
              <option value="">-- Ninguno --</option>
              {horarios.map(h => (
                <option key={h.id} value={h.id}>
                  {h.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Creando...' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCrearHorario;
